var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIcoAlertSuccess(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 298,
    height: 301,
    viewBox: "0 0 298 301",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M42.8637 276.89C-15.2202 243.212-15.2202 188.616 42.8637 154.937 100.947 121.259 195.113 121.259 253.197 154.937 311.281 188.616 311.281 243.212 253.197 276.89 195.113 310.569 100.947 310.569 42.8637 276.89z",
    fill: "#a2eaf3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164.715 246.737C205.71 224.535 230.023 189.927 219.021 169.44 208.019 148.953 165.868 150.344 124.874 172.547 83.8791 194.75 59.5654 229.357 70.5673 249.844 81.5693 270.331 123.721 268.94 164.715 246.737z",
    fill: "#6edfee"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M205.501 198.059C213.698 188.248 226.538 181.847 240.976 178.078 255.23 174.351 257.785 165.543 248.34 162.684 237.63 159.442 224.266 165.4 215.645 173.682 200.625 188.115 198.744 199.162 198.744 199.162L205.501 198.059z",
    fill: "url(#paint0_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.15,
    d: "M205.501 198.059C213.698 188.248 226.538 181.847 240.976 178.078 255.23 174.351 257.785 165.543 248.34 162.684 237.63 159.442 224.266 165.4 215.645 173.682 200.625 188.115 198.744 199.162 198.744 199.162L205.501 198.059z",
    fill: "#000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M201.272 197.483C201.214 197.483 201.147 197.466 201.089 197.441 200.881 197.34 200.798 197.09 200.898 196.881 213.064 171.81 239.984 165.643 246.533 166.111 246.766 166.127 246.932 166.328 246.915 166.562 246.899 166.796 246.682 166.963 246.466 166.946 240.075 166.453 213.621 172.571 201.638 197.249 201.58 197.399 201.43 197.483 201.272 197.483z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M198.732 200.667C198.732 202.438 200.646 203.516 202.169 202.622 209.792 198.168 220.909 195.703 238.908 200.842 248.478 203.575 253.188 201.745 255.202 197.834 257.44 193.488 252.697 189.285 247.288 187.304 228.873 180.543 212.255 185.156 198.732 198.644V200.667z",
    fill: "url(#paint1_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M199.781 201.026C199.664 201.026 199.556 200.976 199.473 200.884 199.323 200.708 199.331 200.449 199.506 200.29 215.408 186.017 240.04 188.8 249.36 194.365 249.56 194.482 249.626 194.741 249.501 194.942 249.385 195.143 249.127 195.201 248.927 195.084 239.79 189.627 215.65 186.919 200.055 200.917 199.98 200.984 199.88 201.026 199.781 201.026z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.6699 232.699C66.6799 221.985 54.6803 214.113 40.7918 208.656 27.0697 203.265 25.5719 194.215 35.2913 192.502 46.3089 190.554 58.8827 198.051 66.4635 207.293 79.6863 223.406 80.2522 234.596 80.2522 234.596L73.6699 232.699z",
    fill: "url(#paint2_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.15,
    d: "M73.6699 232.699C66.6799 221.985 54.6803 214.113 40.7918 208.656 27.0697 203.265 25.5719 194.215 35.2913 192.502 46.3089 190.554 58.8827 198.051 66.4635 207.293 79.6863 223.406 80.2522 234.596 80.2522 234.596L73.6699 232.699z",
    fill: "#000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.931 232.632C77.9893 232.64 78.0559 232.632 78.1141 232.615 78.3305 232.54 78.447 232.297 78.3721 232.08 69.2351 205.747 43.2222 196.429 36.6732 196.12 36.4402 196.112 36.2488 196.287 36.2405 196.521 36.2322 196.755 36.4236 196.947 36.6399 196.956 43.0475 197.223 68.5943 206.433 77.5899 232.356 77.6398 232.515 77.7812 232.615 77.931 232.632z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.3183 234.086C80.0104 236.668 77.0979 238.013 74.9509 236.559 67.8943 231.812 57.3843 228.737 40.1672 231.503 30.3479 233.083 25.8876 230.709 24.3398 226.589 22.6255 222.01 27.8348 218.4 33.4351 217.071 52.5079 212.55 68.4768 219.102 80.3183 234.086z",
    fill: "url(#paint3_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.9939 236.325C79.1104 236.342 79.2269 236.309 79.3185 236.225 79.4932 236.075 79.5099 235.807 79.3518 235.632 65.2386 219.578 40.4489 219.419 30.5381 223.84 30.33 223.932 30.2302 224.183 30.33 224.392 30.4216 224.6 30.6712 224.701 30.8792 224.6 40.5904 220.272 64.8891 220.43 78.7277 236.183 78.8026 236.267 78.8941 236.317 78.9939 236.325z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.964 42.9964 212.839 42.9212C212.831 42.9212 212.831 42.9129 212.822 42.9129L181.101 24.5778C181.092 24.5694 181.084 24.5694 181.068 24.561L180.884 24.4691V24.4775C166.064 16.973 146.292 19.221 125.031 33.035 82.3084 60.78 49.7465 124.644 52.3095 175.671 53.591 201.11 63.3521 218.551 78.1143 226.214V226.222L78.2475 226.289C78.2558 226.289 78.2558 226.297 78.2641 226.297L109.994 244.641C110.002 244.641 110.002 244.649 110.011 244.649L110.169 244.733V244.724C124.989 252.254 144.778 250.006 166.064 236.192 208.786 208.447 241.348 144.583 238.785 93.5559 237.487 68.109 227.726 50.6681 212.964 42.9964z",
    fill: "#37474f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.903 244.056 78.2633 226.289C78.2384 226.289 78.2383 226.289 78.2383 226.289L78.0969 226.206C63.3429 218.517 53.5818 201.076 52.3087 175.671 51.1686 152.915 57.0186 127.619 67.6118 104.119L67.8282 103.601 99.3499 122.454C88.7317 145.946 82.8984 171.242 84.0384 194.007 85.2866 218.91 94.6649 236.134 108.903 244.056z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M166.048 236.183C208.77 208.438 241.332 144.575 238.761 93.5473 236.198 42.5199 199.484 23.6416 156.761 51.3866 114.039 79.1316 81.4769 142.995 84.0399 194.023 86.6113 245.05 123.326 263.928 166.048 236.183z",
    fill: "#455a64"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M202.228 39.0434 148.688 149.806 137.163 137.262C133.609 133.385 128.542 131.162 123.257 131.162 118.481 131.162 113.912 132.95 110.393 136.201 102.728 143.313 102.254 155.372 109.327 163.077L139.692 196.104C143.054 199.764 147.631 201.92 152.582 202.187 152.932 202.204 153.281 202.212 153.631 202.212 154.538 202.212 155.453 202.146 156.377 202.012 162.585 201.084 167.927 197.157 170.648 191.499L232.061 64.4652C225.786 50.3921 215.293 41.634 202.228 39.0434z",
    fill: "#37474f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M245.717 2.55724C245.384 2.36503 245.043 2.18117 244.686 2.01403 236.514-1.95551 226.645 1.47083 222.7 9.65227L154.564 150.6 150.695 146.38C149.538 145.126 148.24 144.09 146.833 143.28 144.803 142.11 136.165 137.087 134.767 136.277 128.709 132.767 120.812 133.427 115.37 138.449 108.713 144.625 108.305 155.096 114.446 161.782L144.811 194.817C145.968 196.07 147.291 197.123 148.731 197.951 150.711 199.087 159.316 204.093 160.73 204.912 162.952 206.207 165.457 206.968 168.095 207.11 169.177 207.168 170.267 207.127 171.39 206.968 176.782 206.166 181.417 202.748 183.781 197.842L264.391 31.0962C268.177 23.249 265.223 13.8475 257.825 9.5687 257.476 9.36814 247.873 3.79406 245.717 2.55724z",
    fill: "#1bd4ed"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.15,
    d: "M245.717 2.55724C245.384 2.36503 245.043 2.18117 244.686 2.01403 236.514-1.95551 226.645 1.47083 222.7 9.65227L154.564 150.6 150.695 146.38C149.538 145.126 148.24 144.09 146.833 143.28 144.803 142.11 136.165 137.087 134.767 136.277 128.709 132.767 120.812 133.427 115.37 138.449 108.713 144.625 108.305 155.096 114.446 161.782L144.811 194.817C145.968 196.07 147.291 197.123 148.731 197.951 150.711 199.087 159.316 204.093 160.73 204.912 162.952 206.207 165.457 206.968 168.095 207.11 169.177 207.168 170.267 207.127 171.39 206.968 176.782 206.166 181.417 202.748 183.781 197.842L264.391 31.0962C268.177 23.249 265.223 13.8475 257.825 9.5687 257.476 9.36814 247.873 3.79406 245.717 2.55724z",
    fill: "#000"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.15,
    d: "M160.722 204.912C159.316 204.093 150.711 199.079 148.722 197.95 147.283 197.123 145.96 196.078 144.803 194.825L114.438 161.798C113.057 160.286 112.016 158.572 111.301 156.776L123.375 163.771C124.091 165.576 125.139 167.289 126.529 168.801L156.894 201.828C158.026 203.056 159.307 204.093 160.722 204.912z",
    fill: "#000"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.15,
    d: "M238.602 11.5662C237.055 12.9535 235.748 14.6666 234.791 16.6472L164.708 161.623 154.572 150.584 222.708 9.63576C223.665 7.64681 224.98 5.942 226.528 4.55475L238.602 11.5662z",
    fill: "#000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256.776 9.01715C248.604 5.0476 238.735 8.47395 234.791 16.6554L164.707 161.631 150.694 146.38C144.569 139.703 134.151 139.277 127.452 145.461 120.795 151.637 120.387 162.108 126.528 168.802L156.893 201.837C159.806 205.012 163.783 206.884 168.086 207.118 169.167 207.177 170.258 207.135 171.381 206.976 176.773 206.174 181.408 202.756 183.772 197.85L264.382 31.1045C268.334 22.8897 264.931 12.9867 256.776 9.01715z",
    fill: "#1bd4ed"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear",
    x1: 265.193,
    y1: 180.324,
    x2: 185.057,
    y2: 180.324,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0f347d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1bd4ed"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear",
    x1: 267.405,
    y1: 193.507,
    x2: 184.587,
    y2: 193.507,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0f347d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1bd4ed"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear",
    x1: 90.6965,
    y1: 213.224,
    x2: 16.3577,
    y2: 213.224,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0f347d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1bd4ed"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear",
    x1: 91.8056,
    y1: 226.324,
    x2: 10.0428,
    y2: 226.324,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0f347d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1bd4ed"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h298v301H0z",
    fill: "#fff"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoAlertSuccess);
export default __webpack_public_path__ + "static/media/ico-alert-success.27b08170c121bfed29cbaf1f1df23442.svg";
export { ForwardRef as ReactComponent };